(function () {
  function cardIn(track) {
    return (
      track.querySelector('.upsell-carousel__card:not([hidden])') ||
      track.querySelector('.product-card') ||
      track.querySelector('.blog-teaser') ||
      track.querySelector('.home-review-card') ||
      track.querySelector('.seek-page__shortcut')
    );
  }

  function bindRail(rail) {
    if (!rail || rail.dataset.railBound === 'true') return;
    var track = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!track) return;
    rail.dataset.railBound = 'true';

    var update = function () {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = maxScroll <= 4 || track.scrollLeft >= maxScroll - 4;
    };

    var step = function () {
      var card = cardIn(track);
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card ? Math.round(card.getBoundingClientRect().width + gap) : Math.round(track.clientWidth * 0.8);
    };

    var scrollByDir = function (dir) {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var nextLeft = Math.max(0, Math.min(maxScroll, track.scrollLeft + dir * step()));
      track.scrollTo({ left: nextLeft, behavior: 'smooth' });
      window.requestAnimationFrame(update);
    };

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(update).observe(track);
    }
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(update).observe(track, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', update, { once: true });
    });
    rail._updateArrows = update;
    window.requestAnimationFrame(update);
  }

  function bindAddButtons() {
    document.querySelectorAll('.product-card__cta[data-add-label]').forEach(function (btn) {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      var form = btn.closest('form');
      if (!form) return;
      form.addEventListener('submit', function () {
        var label = btn.querySelector('.product-card__cta-label');
        btn.classList.add('is-added');
        if (label) label.textContent = btn.dataset.addedLabel || 'Added';
        window.setTimeout(function () {
          btn.classList.remove('is-added');
          if (label) label.textContent = btn.dataset.addLabel || 'Add to cart';
        }, 1400);
      });
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-product-rail]').forEach(bindRail);
    bindAddButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('shopify:section:load', bindAll);
})();
